import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import Chip from '@mui/material/Chip';

import palette from '../../styles/palette';

const useStyles = makeStyles(({ typography }) => ({
  criteriaItem: {
    margin: `${typography.pxToRem(3)} ${typography.pxToRem(8)}`,
    background: palette.typography.white.solid,
    height: typography.pxToRem(22),
    '&:hover, &:focus': {
      backgroundColor: palette.typography.white.solid,
    },
  },
}));

const SelectedCriteriaItem = ({
  label,
  handleDelete,
  handleClick,
  avatar,
  id,
  ...params
}) => {
  const classes = useStyles();

  return (
    <Chip
      className={classes.criteriaItem}
      size="small"
      label={label}
      avatar={avatar}
      onDelete={handleDelete}
      onClick={handleClick}
      key={id}
      {...params}
    />
  );
};

export default memo(SelectedCriteriaItem);
